<template>
  <div id="contenedor-planeacion-main">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'PlaneacionMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
